//@ts-nocheck
import React from "react";

export const ListProductsPage = () => {
  return <div></div>;
};
